let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5Ue7J")).then(() => parcelRequire('jEc6C'));